import { getNewCustomerDiscountExpiresAtUserSelect } from 'modules/training/modules/training-users/selectors/getNewCustomerDiscountExpiresAt/index.js'
import { createSelector } from 'reselect'
import { getSubscriptionPlanUserSelect } from 'modules/training/modules/training-users/selectors/get-subscription-plan/index.js'
import { getSubscriptionCanceledAtUserSelect } from 'modules/training/modules/training-users/selectors/getSubscriptionCanceledAt/index.js'

export const shouldShowNewCustomerDiscountUserSelect = createSelector(
  getNewCustomerDiscountExpiresAtUserSelect,
  getSubscriptionPlanUserSelect,
  getSubscriptionCanceledAtUserSelect,
  (
    newCustomerDiscountExpiresAt,
    subscriptionPlan,
    subscriptionCanceledAt
  ) => {
    if (subscriptionCanceledAt) {
      return false
    }

    if (/sale/i.test(subscriptionPlan)) {
      return true
    }

    if (!newCustomerDiscountExpiresAt) {
      return true
    }

    return new Date(newCustomerDiscountExpiresAt) > new Date()
  }
)
